import { adminSlice, periodSettingsSlice, sobTrackingSlice } from '@clevercraft/distribution-sob'
import { globalPartnerReducer } from 'legacy/lut/features/globalPartner'
import { partner360Reducer } from 'legacy/lut/features/partner360'
import { partnerReducer } from 'legacy/lut/features/partner/partnerSlice'
import { partnerDashboardReduce } from 'legacy/lut/features/partnerDashboard'
import { AnyAction } from 'redux'

import { campaignApi } from 'clickNgo/entities/campaign/api'
import { contactApi } from 'clickNgo/entities/contact'
import { contactFlagApi } from 'clickNgo/entities/contactFlag/api'
import { flagManagementApi } from 'clickNgo/entities/flagManagement/api/flagManagementApi'
import { partnerSpecializationApi } from 'clickNgo/entities/partner/api/partnerSpecializations'
import { promotionsApi } from 'clickNgo/entities/promotionProduct'
import { accessManagementReducer } from 'clickNgo/features/accessManagement'
import { callHistoryApi } from 'clickNgo/features/callHistory'
import { campaignReminderApi } from 'clickNgo/features/campaign/emailReminder/api/campaignReminderApi'
import { partnerSearchReducer } from 'clickNgo/features/partnerSearchStore'
import { widgetEventReducer } from 'clickNgo/features/widgetEvent'
import { widgetReducer } from 'clickNgo/features/widgets'
import { formReducer } from 'cng-common/features/form/formSlice'
import { translationReducer } from 'cng-common/features/translations'
import { getReducer } from 'core/classes/helpers/store/database'
import { onboardingReducer } from 'onboarding/features/onboardingSlice'
import { keyInitiativesApi } from 'partner360/entities/keyInitiatives'
import { masterDealerApi } from 'partner360/entities/masterDealer'
import { pbmCockpitApi } from 'partner360/entities/pbmCockpit'
import { pbmDashboardApi } from 'partner360/entities/pbmDashboard'
import { planFinancialsApi } from 'partner360/entities/planFinancials'
import { planningApi } from 'partner360/entities/planning'
import { espApi } from 'partner360/features/executiveSponsorProgram'
import { extendedPartnerDataReducer } from 'partner360/features/extendedPartnerData'
import { masterDealerDataReducer } from 'partner360/features/masterDealerData'
import { mdOffboardingApi } from 'partner360/features/mdOffboarding'
import { reducer as SearchReducer } from 'search/store'

import { getKeyByForm, relations } from './meta'
import { ILookupOldState, initialLookupState, lookupForms } from './state'

export const LOOKUP_NEXT_STATE = '@LOOKUP_NEXT_STATE'
export const LOOKUP_SET_RWACCESS = '@LOOKUP_SET_RWACCESS'

export const LOOKUP_SET_LANDING_ACCESS_STATE = '@LOOKUP_SET_LANDING_ACCESS_STATE'

export const lookupReducer = getReducer(
  lookupForms,
  relations,
  getKeyByForm,
  '@LOOKUP_SAVE',
  '@LOOKUP_REMOVE'
)

export function lookupOldReducer(state = initialLookupState, action: AnyAction): ILookupOldState {
  switch (action.type) {
    case LOOKUP_SET_LANDING_ACCESS_STATE:
      return {
        ...state,
        landingAccessState: action.payload,
      }
    case LOOKUP_SET_RWACCESS:
      return {
        ...state,
        jbpPartnerAccess: action.payload,
      }
    case LOOKUP_NEXT_STATE:
      return action.state
    default:
      return state
  }
}

const res = {
  periodSettings: periodSettingsSlice.reducer,
  sobTracking: sobTrackingSlice.reducer,
  admin: adminSlice.reducer,

  [callHistoryApi.reducerPath]: callHistoryApi.reducer,
  [contactApi.reducerPath]: contactApi.reducer,
  [mdOffboardingApi.reducerPath]: mdOffboardingApi.reducer,
  [masterDealerApi.reducerPath]: masterDealerApi.reducer,
  [keyInitiativesApi.reducerPath]: keyInitiativesApi.reducer,
  [pbmCockpitApi.reducerPath]: pbmCockpitApi.reducer,
  [pbmDashboardApi.reducerPath]: pbmDashboardApi.reducer,
  [contactFlagApi.reducerPath]: contactFlagApi.reducer,
  [flagManagementApi.reducerPath]: flagManagementApi.reducer,
  [planFinancialsApi.reducerPath]: planFinancialsApi.reducer,
  [planningApi.reducerPath]: planningApi.reducer,
  [promotionsApi.reducerPath]: promotionsApi.reducer,
  [espApi.reducerPath]: espApi.reducer,

  [campaignApi.reducerPath]: campaignApi.reducer,
  [campaignReminderApi.reducerPath]: campaignReminderApi.reducer,
  [partnerSpecializationApi.reducerPath]: partnerSpecializationApi.reducer,

  widgets: widgetReducer,
  widgetEvent: widgetEventReducer,
  masterDealerData: masterDealerDataReducer,
  extendedPartnerData: extendedPartnerDataReducer,
  accessManagement: accessManagementReducer,
  partnerDashboard: partnerDashboardReduce,
  partnerSearch: partnerSearchReducer,
  partner: partnerReducer,
  form: formReducer,
  globalPartner: globalPartnerReducer,
  partner360: partner360Reducer,
  onboarding: onboardingReducer,
  lookupOld: lookupOldReducer,
  lookup: lookupReducer,
  search: SearchReducer.search,
  translations: translationReducer,
}

export { res as lutReducer }
